export default __webpack_public_path__ + "static/media/complete_bg.28d763bd.svg";